import React from "react";
import "./image-frame.scss";

interface ImageFrameProps {
    imageSource: any;
    imageTitle: string;
}

export const ImageFrame = (props: ImageFrameProps) => {
    return (
        <div className="image-frame dark-background">
            <div className="outer-border">
                <div className="mid-border">
                    <div className="inner-border">
                            <img src={props.imageSource} alt={props.imageTitle} />
                    </div>
                </div>
            </div>
        </div>
    )
}